import { render, staticRenderFns } from "./periodo.vue?vue&type=template&id=34409ffb"
import script from "./periodo.vue?vue&type=script&lang=js"
export * from "./periodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports